import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RoleGaurd } from 'src/app/shared/services/role-gaurd.service';
import { MixDesignSearchResultComponent } from './mix-design-search-result/mix-design-search-result.component';
import { MixDesignDashboardComponent } from './mix-design-dashboard/mix-design-dashboard.component';
import { AddEditMixDesignComponent } from './add-edit-mix-design/add-edit-mix-design.component';
import { GeothermMixDesignComponent } from './geotherm-mix-design/geotherm-mix-design.component';

const routes: Routes = [
  {
    path: '',
    component : MixDesignDashboardComponent,
    canActivate: [RoleGaurd],
    data: {
      roles: ['Admin','Manager', 'Reportwriter'],
      title: 'Mix Design - Dashboard',
    }
  },
  {
    path: 'search',
    component : MixDesignSearchResultComponent,
    canActivate: [RoleGaurd],
    data: {
      roles: ['Admin','Manager', 'Reportwriter'],
      title: 'Mix Design - Search',
    }
  },
  {
    path: 'client/new',
    component : AddEditMixDesignComponent,
    canActivate: [RoleGaurd],
    data: {
      roles: ['Admin','Manager', 'Reportwriter'],
      title: 'Client Mix Design',
    },
  },
  {
    path: 'client/edit/:id',
    component : AddEditMixDesignComponent,
    canActivate: [RoleGaurd],
    data: {
      roles: ['Admin','Manager', 'Reportwriter'],
      title: 'Client Mix Design',
    },
  },
  {
    path: 'geotherm/edit/:id',
    component : GeothermMixDesignComponent,
    canActivate: [RoleGaurd],
    data: {
      roles: ['Admin','Manager', 'Reportwriter'],
      title: 'Geotherm Mix Design',
    },
  },
  {
    path: 'client/copy/:id',
    component : AddEditMixDesignComponent,
    canActivate: [RoleGaurd],
    data: {
      roles: ['Admin','Manager', 'Reportwriter'],
      title: 'Client Mix Design',
    },
  },
  {
    path: 'geotherm/copy/:id',
    component : GeothermMixDesignComponent,
    canActivate: [RoleGaurd],
    data: {
      roles: ['Admin','Manager', 'Reportwriter'],
      title: 'Geotherm Mix Design',
    },
  },
  {
    path: 'geotherm/new',
    component : GeothermMixDesignComponent,
    canActivate: [RoleGaurd],
    data: {
      roles: ['Admin','Manager', 'Reportwriter'],
      title: 'Geotherm Mix Design',
    },
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MixDesignRoutingModule { }
